import { Link } from "react-router-dom";

export function Logo({ variant = "dark", className = "" }) {
  const isDark = variant === "dark"; // dark text on light bg
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-center ${className}`}
      aria-label="XL Brokers — We change the way you insure yourself"
    >
      <img
        src="/xl-brokers-logo.png"
        alt="XL Brokers"
        className={`h-10 sm:h-11 w-auto object-contain ${isDark ? "" : "brightness-0 invert"}`}
        draggable="false"
      />
    </Link>
  );
}
